
export const editDnsPageTitle = {
    en: "Edit DNS Settings",
    ru: "Редактирование DNS-настроек",
    am: "DNS կարգավորումների խմբագրում",
};

export const editDnsPageFormBtnText = {
    en: "Save",
    ru: "Сохранить",
    am: "Պահպանել",
};
